import {ApiResponse, PaginatedApiReponse} from '../models/ApiResponse';
import {CreateFeedbackPayload, Feedback} from '../models/Feedback/Feedback';
import {apiClient} from './baseApiClient';

class FeedbackApi {
  public async getFeedbackList(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
  ): Promise<PaginatedApiReponse<Feedback>> {
    return apiClient.post(`/feedback/${organizationId}/list`, {
      page,
      pageSize,
      search: search || undefined,
      orderBy: 'date_created',
      orderAsk: false,
    });
  }

  public async getFeedback(
    organizationId: string,
    feedbackId: string,
  ): Promise<ApiResponse<Feedback>> {
    return apiClient.get(`/feedback/${organizationId}/${feedbackId}`);
  }

  public async createFeedback(
    organizationId: string,
    payload: CreateFeedbackPayload,
  ): Promise<ApiResponse<Feedback>> {
    return apiClient.post(`/feedback/${organizationId}/create`, payload);
  }

  public async deleteFeedback(
    organizationId: string,
    feedbackId: string,
  ): Promise<ApiResponse<any>> {
    return apiClient.delete(`/feedback/${organizationId}/${feedbackId}`);
  }
}

export default FeedbackApi;
